import { Component, OnInit } from '@angular/core';
import { Branding } from '@services/branding.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit {
  logoUrl = '';
  logoLink: string | null = null;

  ngOnInit(): void {
    const branding = sessionStorage.getItem('branding');
    if (branding) {
      const parsed = JSON.parse(branding) as Branding;
      this.logoUrl = parsed.logo || '';
      this.logoLink = parsed.logoLink?.trim() || null;
    }
  }
}
